import React from 'react'
import { ShoppingOutlined, DollarOutlined, CustomerServiceOutlined, CreditCardOutlined } from '@ant-design/icons';
import { Col, Row, Typography } from 'antd';
const services = [
    { icon: <ShoppingOutlined />, title: "Free Shipping", description: "Free shipping for order above $150" },
    { icon: <DollarOutlined />, title: "Money Guarantee", description: "Within 30 days for an exchange" },
    { icon: <CustomerServiceOutlined />, title: "Online Support", description: "24 hours a day, 7 days a week" },
    { icon: <CreditCardOutlined />, title: "Flexible Payment", description: "Pay with multiple credit cards" },
];

const { Title, Paragraph } = Typography;
export default function OurServices() {
    return (
        <section className='bg-white'>
            <div className="container">
                <Row gutter={[16, 16]} className='py-5'>
                    {services.map((service, index) => (
                        <Col xs={24} sm={12} md={6} key={index} className="text-start">
                            {React.cloneElement(service.icon, { style: { fontSize: '2rem' } })}
                            <Title level={5} className="mt-3 mb-2">{service.title}</Title>
                            <Paragraph className="text-muted">{service.description}</Paragraph>
                        </Col>
                    ))}
                </Row>
            </div>
        </section>
    )
}
